/*
 ReduxBasket

 Koszyk rezerwacji - z wykorzystaniem Redux (implementacja w appredux)
 Stan koszyka: store.getState().pageState.basket
 Wywołanie akcji: store.dispatch(Actions.pageState.updateBasket(<nowy koszyk>));

 do zrobienia:
  połączyć basket z reservation

*/
import React from 'react';

import { Button, Typography }
    from '@material-ui/core';
import { Theme, withStyles, WithStyles, MuiThemeProvider } from "@material-ui/core/styles";
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';

import { AppState, Actions, store, PanelState, IPageState } from '../../appredux';

import { RezerwacjaPobyt, bookService, payServicePrzelewy24, ReservationId, Przelewy24Status, vscPaymentPrzelewy24, Result, User, userService } from '../../api';

import CONFIG from '../../cfg/config';

import { Trans, WithTranslation, withTranslation, TransProps } from 'react-i18next';

import { connect, Provider } from 'react-redux';

import TodayIcon from '@mui/icons-material/Today';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import BedroomParentIcon from '@mui/icons-material/BedroomParent';
import BedroomParentOutlinedIcon from '@mui/icons-material/BedroomParentOutlined';
import KingBedIcon from '@mui/icons-material/KingBed';
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import PersonIcon from '@mui/icons-material/Person';
import GroupIcon from '@mui/icons-material/Group';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import PinIcon from '@mui/icons-material/Pin';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import PasswordIcon from '@mui/icons-material/Password';

import DialogZarzadzaj, { Content } from './DialogZarzadzaj';
import { daysFromDate, sendErrorLog, phoneSplit, selectTheme, datediff } from '../common/helpers';
import moment from 'moment';
import Klawiatura from 'app/common/Klawiatura';
import ReactDOM from 'react-dom';
import theme from 'themes/themes';

type ZarzadzajRezerwacjaProps = {
    page: IPageState,
    open: boolean,
    close: () => void,
    rezerwacja: string,
    telefon: string,
}

type ZarzadzajRezerwacjaState = {
    fromDate: string,
    toDate: string,
    nrRezerwacji: string,
    nrTelefonu: string,
    backdrop: boolean,
    openCancell: boolean,
    success: boolean,
    openZarzadzaj: boolean,
    dialogContentSuccess: Content[],
    dialogContentFailure: Content[],
    successDialogZarzadzaj: boolean,
    rezerwacjaPobyt: RezerwacjaPobyt,
    paymentState: number,
    reminderInterval: boolean,
}

const wciecie: string = '  * ';

class ZarzadzajRezerwacja extends React.Component<ZarzadzajRezerwacjaProps & WithTranslation & WithStyles<typeof styles> & TransProps, ZarzadzajRezerwacjaState> {

    stylInputaRezerwacja: React.CSSProperties = { padding: "8px 14px", textAlign: "left", fontWeight: "bold" };

    constructor(props: ZarzadzajRezerwacjaProps & WithTranslation & WithStyles<typeof styles> & TransProps) {
        super(props, {});
        this.state = {
            fromDate: this.props.page.dateFrom,
            toDate: this.props.page.dateTo,
            backdrop: true,
            openCancell: false,
            nrRezerwacji: '',
            nrTelefonu: '',
            success: false,
            openZarzadzaj: false,
            dialogContentSuccess: [],
            dialogContentFailure: [],
            successDialogZarzadzaj: false,
            rezerwacjaPobyt: new RezerwacjaPobyt(),
            paymentState: 0,  // -1  - porażka   0 - nie wiadomo     1 - w trakcie     2 - sukces   3 - oczekiwanie na potwierdzenie   
            reminderInterval: true,
        }
    }

    interval: any;
    timeout: any;

    async componentDidMount() {    
        if (this.props.page.rezerwacjaAnuluj == 0 &&  this.props.rezerwacja != "" && this.props.telefon != ""  ) {
            await this.setState({ nrRezerwacji: this.props.rezerwacja, nrTelefonu: this.props.telefon });
            this.getReservation()
            store.dispatch(Actions.pageState.setRezerwacjaAnuluj(1));
        }
    }

    // async componentDidUpdate(prevProps: ZarzadzajRezerwacjaProps, prevState: ZarzadzajRezerwacjaState) {
    //     if (this.state.paymentState !== prevState.paymentState && prevState.paymentState !== 0) {
    //       await  this.getReservation()      
    //     };
    //   }

    async componentDidUpdate(prevProps: ZarzadzajRezerwacjaProps, prevState: ZarzadzajRezerwacjaState) {
        let openRes = this.props.page.openRezerwacjaZarzadzaj
        if (openRes.tel !== "" && openRes.nr !== 0 && openRes.open !== prevProps.page.openRezerwacjaZarzadzaj.open) {
            await this.setState({ nrRezerwacji: openRes.nr.toString(), nrTelefonu: openRes.tel });
            this.getReservation()
            store.dispatch(Actions.pageState.setRezerwacjaAnuluj(1));
        }
    }


    setDates = async (pobyt: RezerwacjaPobyt) => {
        if (this.props.page.rezerwacjaAnuluj == 1 && this.state.nrRezerwacji != "" && this.props.telefon != "") {
            let date = new Date(pobyt.pobyt_od);
            date.setHours(2)
            if (date.getTime() < new Date().getTime()) {
                let diff = datediff(new Date(this.props.page.dateFrom), new Date(this.props.page.dateTo))
                store.dispatch(Actions.pageState.setDateFrom(daysFromDate(new Date(), 0)));
                store.dispatch(Actions.pageState.setDateTo(daysFromDate(new Date(), diff)));
            } else {
                store.dispatch(Actions.pageState.setDateFrom(pobyt.pobyt_od));
                store.dispatch(Actions.pageState.setDateTo(pobyt.pobyt_do));
            }
            store.dispatch(Actions.pageState.setRezerwacjaAnuluj(2));
        }
    }

    closeDialog = () => {
        this.setState({ ...this.state, nrRezerwacji: '', nrTelefonu: '', openCancell: false, backdrop: true });
        store.dispatch(Actions.pageState.setRezerwacjaAnuluj(2));
        this.props.close();
    }

    getNrRezerwacji = (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
        this.setState({
            ...this.state,
            nrRezerwacji: String(event.target.value)
        });
    }

    getNrTelefonu = (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
        this.setState({
            ...this.state,
            nrTelefonu: String(event.target.value)
        });
    }

    //PM 2021-10-20
    //await store.dispatch(Actions.pageState.setLangPhone({ flag: this.props.page.lang, prefix: '' }));
    handleCloseWithoutModal = async () => {
        await store.dispatch(Actions.pageState.setLangPhone({ flag: this.props.page.lang, prefix: '' }));
        this.setState({ ...this.state, openZarzadzaj: false, backdrop: true });
        clearInterval(this.interval);
        clearTimeout(this.timeout);
    }

    getReservation = async () => {
        if (!this.state.nrRezerwacji.replace(/\s/g, "").match(/(^\d{1,}$)/)) {
            return;
        }
        this.setState({success: false, paymentState: 0, reminderInterval: true,})

        const { t } = this.props;
        const nrRezerwacji = Number(this.state.nrRezerwacji);
        let success = false;
        let reserv = new RezerwacjaPobyt();
        let dialogContentSuccess: Content[];
        let dialogContentFailure: Content[];

        try {
            const res = await bookService.reservGet
                ({
                    hotelId: CONFIG.hotelID,
                    aOperatorId: Number(sessionStorage.getItem("operator_id")),
                    aPobytId: nrRezerwacji,
                    aDomena: this.props.page.lang,
                }, {});
                //console.log(res.result[0].tag_uwagi_10 == "0" ? "zapłacono" : "rezerwacja trwa"  )
                //console.log(res.result[0])
                await this.downloadHasla(nrRezerwacji.toString())
                
                if(this.props.page.contact.payWeb === "1" && res.result[0].tag_uwagi_10 === "1" && this.state.nrRezerwacji !== "" && this.state.paymentState === 0){
                    await this.setPaymentInterval() // sprawdzanie stanu
                } else if(this.props.page.contact.payWeb === "1" && res.result[0].tag_uwagi_10 === "0" && res.result[0].status_id === 2){
                    this.setState({paymentState: 2}) // sukces
                } else if(this.props.page.contact.payWeb === "1" && res.result[0].tag_uwagi_10 === "0" && res.result[0].status_id === 1){
                    this.setState({paymentState: -1}) //porażka
                }

            if ( res.result.length > 0 && res.result[0].pobyt_id === nrRezerwacji) {
                const dajPobytTelNr = res.result[0].gosc_telefon.replace(/\s/g, '');
                const telNr = this.state.nrTelefonu.replace(/\s/g, '');

                if (dajPobytTelNr === telNr || dajPobytTelNr === "") {
                    success = true;
                    reserv = res.result[0];
                }
                else if (dajPobytTelNr.length > 9 && telNr.length === 9) {
                    const tymTelNr = dajPobytTelNr.slice(dajPobytTelNr.length - 9);

                    if (tymTelNr === telNr) {
                        success = true;
                        reserv = res.result[0];
                    }
                }
            }
            //console.log(res)    
        } catch (error) {
            await sendErrorLog("0", "-1", '/manager/recepcjaDajPobyt')
            await store.dispatch(Actions.pageState.addFcmLogMessage("/manager/recepcjaDajPobyt", 2))
            console.log(error);
            //alert(error)
        }

        const status = reserv.status_id === 0 ?
            'brak - lack' : reserv.status_id === 1 ?
                'wolny - free' : reserv.status_id === 2 ?
                    'rezerwacja - book' : reserv.status_id === 3 ?
                        'meldunek - busy' : reserv.status_id === 0 ?
                            'wyłączenie - off' : '';
        const paymentStatus = this.state.paymentState === -1 ?
            'niepowodzenie' : this.state.paymentState === 0 ?
                'brak informacji' : this.state.paymentState === 1 ?
                    'oczekiwanie na płatność' : this.state.paymentState === 3 ?
                        'oczekiwanie na potwierdzenie' : this.state.paymentState === 2 ?
                            'sukces' :  '';                    

        if (success) {
            reserv.notes_tresc = reserv.notes_tresc.split('|').join('\n');
            dialogContentSuccess = [
                { message: t('Your booking').charAt(0).toUpperCase() + t('Your booking').slice(1) },
                { icon: TodayIcon, message: t("Booking") + ': ', messageBoldPrimary: this.state.nrRezerwacji },
                { icon: EventAvailableIcon, message: t("status") + ': ', messageBoldPrimary: status },
                //{ message: wciecie + t("Booking") + ': ', messageBoldPrimary: reserv.pobyt_od + " / " + reserv.pobyt_do },
                { icon: TodayIcon, message: t("termin") + ': ', messageBoldPrimary: reserv.pobyt_od + " (" + moment(reserv.pobyt_od).format('dd').toLowerCase() + ")" + " / " + reserv.pobyt_do + " (" + moment(reserv.pobyt_do).format('dd').toLowerCase() + ")" },
                { icon: KingBedIcon, message: t('Room').toLowerCase() + ': ', messageBoldPrimary: reserv.rodz_pokoi_opis },
                { icon: GroupIcon, message: t("Person Number") + ': ', messageBoldPrimary: String(reserv.ilosc_osob) },
                { message: " ", messageBoldPrimary: " " },
                { icon: PersonIcon, message: t('Guest Details') + ': ', messageBoldPrimary: reserv.gosc_nazwisko },
                { icon: PhoneIcon, message: t('Your phone') + ': ', messageBoldPrimary: phoneSplit(reserv.gosc_telefon) },
                // { message: wciecie + t('Your advance') + ': ', messageBoldPrimary: reserv.zaliczki },
                { icon: MonetizationOnIcon, message: t('Brutto') + ': ', messageBoldPrimary: reserv.brutto  },
                
            ];
            if(this.props.page.contact.payWeb === "1") dialogContentSuccess.push({ icon: CurrencyExchangeIcon, message: t('Payment state') + ': ', messageBoldPrimary: paymentStatus, color: this.state.paymentState === 2 ? undefined : "#3a87ad" })
            dialogContentFailure = dialogContentSuccess;
            this.setDates(reserv)

            let haslo = this.props.page.rezerwacjaHaslo  
            if(reserv.status_id === 3 && ( haslo.autolockPokojPasscode || haslo.autolockObiektPasscode || haslo.autolockParkingPasscode || haslo.autolockPietroPasscode)){

                dialogContentSuccess.push(
                    { message: " ", messageBoldPrimary: " " },
                    // { message: wciecie2 + "auto lock", messageBoldPrimary: " " },
                    { icon: PasswordIcon, message: this.tlumaczeniaPokoj() + " hasło: ", messageBoldPrimary: haslo.autolockPokojPasscode },
                    { icon: PasswordIcon, message: this.tlumaczeniaObiekt() + " hasło: ", messageBoldPrimary: haslo.autolockObiektPasscode },
                    { icon: PasswordIcon, message: this.tlumaczeniaParking() + " hasło: ", messageBoldPrimary: haslo.autolockParkingPasscode },
                    { icon: PasswordIcon, message: this.tlumaczeniaPietro() + " hasło: ", messageBoldPrimary: haslo.autolockPietroPasscode },
                )
               
            }
        } else {
            dialogContentFailure = [
                { message: t("Reserv not found") },
                { message: wciecie + t("Booking") + ' ', messageBoldPrimary: this.state.nrRezerwacji },
                { message: wciecie + t("Phone nr") + ' ', messageBoldPrimary: phoneSplit(this.state.nrTelefonu) },
                { message: " ", messageBoldPrimary: " " },
                { message: wciecie, messageBoldPrimary: t("Agin") },
                { message: wciecie, messageBoldPrimary: t("Phone Contact") }
            ];
            dialogContentSuccess = dialogContentFailure;
        }

        this.setState({
            ...this.state,
            backdrop: false,
            openZarzadzaj: true,
            dialogContentSuccess: dialogContentSuccess,
            dialogContentFailure: dialogContentFailure,
            successDialogZarzadzaj: success,
            rezerwacjaPobyt: reserv,
        });
    }

    setPaymentInterval = async () => {
        let timeRemain : number
        try {
            
            let payment: Przelewy24Status = await this.paymentState(this.state.nrRezerwacji)
            let dateString: string = payment.data.date
            let payDate = new Date(dateString.slice(0,4) + "-" + dateString.slice(4,6) + "-" + dateString.slice(6,8) + " " + dateString.slice(8,10) + ":" + dateString.slice(10,12))

            //2021-11-18 10:32

            //console.log(new Date().toISOString())
            //console.log(new Date(payment.akcjaDtStart).toISOString())
            timeRemain = payDate.getTime() + 15 * 60000 - new Date().getTime() 
            //console.log(timeRemain)
            //console.log(payment)
            //console.log(timeRemain /60000)
            if (payment && (CONFIG.preautoryzacja === '0' && payment.data.status === 2 || CONFIG.preautoryzacja === '1' && payment.data.status === 1)) {
                this.sendSuccess();
                this.setState({ paymentState: 2 })
            } else if (timeRemain > 0) {
                this.setState({ paymentState: 1 })
                this.interval = setInterval(() => {
                    this.paymentState(this.state.nrRezerwacji);
                }, 10000); //10s

                //brak anulacji
                // this.timeout = setTimeout(() => {
                //     //if(this.state.isFailure ){
                //         this.setState({ paymentState: -1 })
                //         this.sendFailure();
                //     //}
                //     clearInterval(this.interval);
                    
                //     //this.setState({ ...this.state, status: 'NegativeFinish' });
                // }, timeRemain);

            } else {

                this.setState({ paymentState: -1 })
            } 

        } catch (error) {
            console.log(error)
        } 
      }

      setReminderInterval = () => {
        this.interval = setInterval(() => {
          this.paymentState(this.state.nrRezerwacji);
        }, 5000);
        this.timeout = setTimeout(() => {
          //if(this.state.isFailure){
             //????????????????????????????????????????????????????
             this.sendSuccess();
             this.setState({ paymentState: 2 })
             clearInterval(this.interval);
             sendErrorLog("0", "-1", `platnosc stan 1, powinien być 2 powrot ${CONFIG.hotelID +":"+ this.state.nrRezerwacji}`)
             store.dispatch(Actions.pageState.addFcmLogMessage(`platnosc stan 1, powinien być 2 powrot ${CONFIG.hotelID +":"+ this.state.nrRezerwacji}`, 2))
          //}  
          //}  
          clearInterval(this.interval);
        }, 30000); //30 s
      }

      async paymentState(id: string) {
        //console.log("status")
        let res: Przelewy24Status = new Przelewy24Status()
        try {
            //if(CONFIG.preautoryzacja === '0' ){  //płatność przelewem
            if(this.props.page.preautoryzacja === 0) {  //płatność przelewem

                res = await payServicePrzelewy24.getStatusPrzelewy24({ hotelId: CONFIG.hotelID, vscNr:  Number(id), prefiks: CONFIG.payWebPrefiks, kontoId: CONFIG.payWebKontoId, })
                //console.log(res2)
                if (res && res.data.status === 1) {

                    // if (this.state.reminderInterval) {
                    //     this.sendConfirmation(res)
                    //     clearInterval(this.interval);
                    //     clearTimeout(this.timeout);
                    //     this.setReminderInterval()
                    //     this.setState({ reminderInterval: false })
                    // }

                } else if (res && res.data.status === 2) {

                    this.setState({ paymentState: 2})//} isFailure: false })
                    clearInterval(this.interval);
                    clearTimeout(this.timeout);

                    const pobyt = await bookService.reservGet
                    ({
                        hotelId: CONFIG.hotelID,
                        aOperatorId: Number(sessionStorage.getItem("operator_id")),
                        aPobytId: Number(this.state.nrRezerwacji),
                        aDomena: this.props.page.lang,
                    }, {});
        
                    if(pobyt && pobyt.result[0] &&pobyt.result[0].status_id === 2){
                      this.sendSuccess();
                    }

                    
                    //this.sendSuccess();
                }
       
            //} else if(CONFIG.preautoryzacja === '1') { // płatność kartą, preautoryzacja
            } else if(this.props.page.preautoryzacja === 1) {  // płatność kartą, preautoryzacja

                res = await payServicePrzelewy24.getStatusPrzelewy24({ hotelId: CONFIG.hotelID, vscNr:  Number(id), prefiks: CONFIG.payWebPrefiks, kontoId: CONFIG.payWebKontoId, })
                //console.log(res3)
                if (res && res.data.status === 1) {
                  //this.sendConfirmation(res3)
                  this.sendSuccess();
                  this.setState({ paymentState: 2})//, isFailure: false })
                  clearInterval(this.interval);
                  clearTimeout(this.timeout);
                }else if (res && res.data.status === 2) {
                    //this.sendConfirmation(res3)
                    this.sendSuccess();
                    this.setState({ paymentState: 2})
                    clearInterval(this.interval);
                    clearTimeout(this.timeout);
                    await sendErrorLog("0", "-1", `preautoryzacja stan 2 powrot ${res.data.sessionId}`)
                    await store.dispatch(Actions.pageState.addFcmLogMessage(`preautoryzacja stan 2 powrot ${res.data.sessionId}`, 2))
                  }
            }
    
        } catch (error) {
          await sendErrorLog("0", "-1", 'pobranie stanu platnosci')
          await store.dispatch(Actions.pageState.addFcmLogMessage("pobranie stanu platnosci", 2))
          console.log(error)
        }
        return res
      }

    async sendConfirmation(status: Przelewy24Status, anuluj: number= 0) {
        try {
            let res: vscPaymentPrzelewy24 = await payServicePrzelewy24.getConfirmation(
                {
                    hotelId: CONFIG.hotelID,
                    vscKwota: status.data.amount,
                    vscId: Number(this.state.nrRezerwacji),
                    anuluj: anuluj // 0- sukces  1- porażka

                }, {})
            //console.log(res)  
        } catch (error) {
            await sendErrorLog("0", "-1", '/vscPay/przelewy24/potwierdzenie')
            await store.dispatch(Actions.pageState.addFcmLogMessage("/vscPay/przelewy24/potwierdzenie", 2))
            console.log(error);
        }
    }

    async sendSuccess() {
        if (CONFIG.payWebPotwierdzAktywny === "1") {
            try {
                let res: ReservationId = await bookService.reservConfirm(
                    {
                        hotelId: CONFIG.hotelID,
                        aOperatorId: Number(sessionStorage.getItem("operator_id")),
                        aPobytId: Number(this.state.nrRezerwacji) || 0
                    }, {})
                this.getReservation()
                clearInterval(this.interval);
                clearTimeout(this.timeout);
                //console.log(res)  
            } catch (error) {
                await sendErrorLog("0", "-1", '/manager/recepcjaPobytPotwierdz')
                await store.dispatch(Actions.pageState.addFcmLogMessage("/manager/recepcjaPobytPotwierdz", 2))
                console.log(error);
            }
        }
    }
    
      async sendFailure() {
        try {
          let res: ReservationId = await bookService.reservCancel(
            {
              hotelId: CONFIG.hotelID,
              aOperatorId: Number(sessionStorage.getItem("operator_id")),
              aPobytId: Number(this.state.nrRezerwacji) || 0
            }, {})
            this.getReservation()
            clearInterval(this.interval);
            clearTimeout(this.timeout);
          //console.log(res)    
        } catch (error) {
          await sendErrorLog("0", "-1", '/manager/recepcjaPobytAnuluj')
          await store.dispatch(Actions.pageState.addFcmLogMessage("/manager/recepcjaPobytAnuluj", 2))
          console.log(error);
        }
      }

    cancellReservation = async () => {
        this.props.close();
        store.dispatch(Actions.pageState.setPanelState(PanelState.psReservPending));

        try {
             //anulacja płatności
             //if(this.props.page.contact.payWeb === "1" && this.props.page.preautoryzacja === 1){
                let payRes = await payServicePrzelewy24.getStatusPrzelewy24({ hotelId: CONFIG.hotelID, vscNr:  Number(this.state.nrRezerwacji), prefiks: CONFIG.payWebPrefiks, kontoId: CONFIG.payWebKontoId, })
                //console.log(payRes)
                if(payRes.data.status === 1){ // zablokowane środki
                    this.sendConfirmation(payRes, 1) //anulacja przelewu
                    await sendErrorLog("1", "1", "zwrot platnosci")
                    await store.dispatch(Actions.pageState.addFcmLogMessage("zwrot platnosci", 0)) 
                }
            //}           
        } catch (error) {
            console.log(error);
        }
        try {
            let res: any = await bookService.reservCancel
                ({
                    hotelId: CONFIG.hotelID,
                    aOperatorId: Number(sessionStorage.getItem("operator_id")),
                    aPobytId: Number(this.state.nrRezerwacji)
                }, {})

            if (res.result[0] > 0) {
                this.setState({ openCancell: true, success: true })
            } else {
                this.setState({ openCancell: true, success: false })
            }

            await sendErrorLog("1", "1", "anulacja rezerwacji")
            await store.dispatch(Actions.pageState.addFcmLogMessage("anulacja rezerwacji", 0)) 
            
        } catch (error) {
            await sendErrorLog("0", "-1", '/manager/recepcjaPobytAnuluj')
            await store.dispatch(Actions.pageState.addFcmLogMessage("/manager/recepcjaPobytAnuluj", 2))
            console.log(error);
        }
        store.dispatch(Actions.pageState.setPanelState(PanelState.psBrowse));
    }

    downloadHasla = async (id: string) => {
        let operator = await this.getUserData()
        if(operator.operator_id){
            await this.downloadHaslaService(id, operator)
        }
    }
        

    async getUserData() {
        try {
          let res: Result<User> = await userService.getUserInfo
            ({ hotelId: CONFIG.hotelID, aId: 1 }, {})
          //store.dispatch(Actions.pageState.setOperators(res.result));
          return res.result[0]

      
        } catch (error) {
          console.log(error);
          await sendErrorLog("0", "-1", '/manager/dajOperatorzy0')
          await store.dispatch(Actions.pageState.addFcmLogMessage("/manager/dajOperatorzy0", 2))
          return new User()
        }
      }

    downloadHaslaService = async (id: string, operator: User) => {
        try {
    
          let res = await bookService.dajHasla(
            { param0: 
              { 
                hotelId: CONFIG.hotelID, 
                pobytId: id,
                ident_oper: operator.ident_oper,
                nazwisko: operator.nazwisko
      
              } 
          }, {})
          if (res.result[0]) {
             store.dispatch(Actions.pageState.setRezerwacjaHasla(res.result[0]))
          }

    } catch (err) {
      await sendErrorLog( "0", "-1", '/rezerwacje/dajHasla')
      await store.dispatch(Actions.pageState.addFcmLogMessage('/rezerwacje/dajHasla', 2))
      console.log(err);
    }
   
  }

  tlumaczeniaParking = () => {
    let index = CONFIG.lang.findIndex(x => x == this.props.page.lang)
    let ret 
  
    switch (index) {
        case 0:
            ret = CONFIG.menu1ParkingOpis1
            break;
        case 1:
            ret = CONFIG.menu1ParkingOpis2
            break;
        case 2:
            ret = CONFIG.menu1ParkingOpis3
            break;
        case 3:
            ret = CONFIG.menu1ParkingOpis4
            break;
        default:
            break;
    }
  
    if(!ret)  ret = "parking"
    return ret
  }
  
  tlumaczeniaObiekt = () => {
    let index = CONFIG.lang.findIndex(x => x == this.props.page.lang)
    let ret 
  
    switch (index) {
        case 0:
            ret = CONFIG.menu1ObiektOpis1
            break;
        case 1:
            ret = CONFIG.menu1ObiektOpis2
            break;
        case 2:
            ret = CONFIG.menu1ObiektOpis3
            break;
        case 3:
            ret = CONFIG.menu1ObiektOpis4
            break;
        default:
            break;
    }
  
    if(!ret)  ret = "obiekt"
    return ret
  } 
  
  tlumaczeniaPietro= () => {
    let index = CONFIG.lang.findIndex(x => x == this.props.page.lang)
    let ret 
  
    switch (index) {
        case 0:
            ret = CONFIG.menu1PietroOpis1
            break;
        case 1:
            ret = CONFIG.menu1PietroOpis2
            break;
        case 2:
            ret = CONFIG.menu1PietroOpis3
            break;
        case 3:
            ret = CONFIG.menu1PietroOpis4
            break;
        default:
            break;
    }
  
    if(!ret)  ret = "piętro" 
    return ret
  } 
  
  tlumaczeniaPokoj = () => {
    let index = CONFIG.lang.findIndex(x => x == this.props.page.lang)
    let ret 
  
    switch (index) {
        case 0:
            ret = CONFIG.menu1PokojOpis1
            break;
        case 1:
            ret = CONFIG.menu1PokojOpis2
            break;
        case 2:
            ret = CONFIG.menu1PokojOpis3
            break;
        case 3:
            ret = CONFIG.menu1PokojOpis4
            break;
        default:
            break;
    }
  
    if(!ret)  ret = "pokój" 
    return ret
  }

    openKlawiaturaRez = () => {
        const { t, classes } = this.props;
        ReactDOM.render(
            <Provider store={store}>
                <MuiThemeProvider theme={theme}>
                    <Klawiatura  randomNum={Math.random()} val={this.state.nrRezerwacji} placeholder={t("booking number")} type={"number"} onConfirm={(rez: string) => this.setState({ nrRezerwacji: rez})} /> 
                </MuiThemeProvider>
            </Provider>, document.getElementById("dialogKlawiatura"))
    } 
    openKlawiaturaTel = () => {
        const { t, classes } = this.props;
        ReactDOM.render(
            <Provider store={store}>
                <MuiThemeProvider theme={theme}>
                    <Klawiatura  randomNum={Math.random()} val={this.state.nrTelefonu} placeholder={t("phone number")} type={"number"} onConfirm={(tel: string) => this.setState({ nrTelefonu: tel})} /> 
                </MuiThemeProvider>
            </Provider>, document.getElementById("dialogKlawiatura"))
    }

    render() {

        const { t, classes } = this.props;
        //console.log(this.state)

        return (
            <>
                <Dialog
                    disableEscapeKeyDown
                    maxWidth="xs"
                    open={this.props.open}
                    onClose={this.closeDialog}
                    fullWidth
                    BackdropProps={{
                        open: this.state.backdrop ? true : false
                    }}
                >
                    <DialogTitle disableTypography style={{paddingBottom: "5px"}}>
                        <Typography variant="h6" component="h2" color="primary">
                            <b><Trans>Search</Trans></b>
                        </Typography>
                        <hr/>
                    </DialogTitle>
                    <DialogContent>
                        <FormControl variant="outlined" margin="normal" fullWidth>
                            <FormLabel className={classes.dialogContentText}>
                                <Trans>Please enter your booking number</Trans>
                            </FormLabel>
                            <TextField
                                onChange={this.getNrRezerwacji}
                                onClick={CONFIG.hotelKiosk === "1" ? this.openKlawiaturaRez : () => {}}
                                className={classes.floatLeft}
                                style={{ width: '85%' }}
                                variant="outlined"
                                inputProps={{ style: { backgroundColor: this.state.nrRezerwacji ? this.props.page.secondaryLight : '#ffffff' } }}
                                InputProps={{ classes: { input: `${classes.primary} ${classes.input}` } }}
                                value={this.state.nrRezerwacji}
                                type='number'
                                autoFocus={CONFIG.hotelKiosk === "1" ? false : true}
                            />
                        </FormControl>
                        <FormControl variant="outlined" margin="normal" fullWidth>
                            <FormLabel className={classes.dialogContentText}>
                                <Trans>Please enter your phone number</Trans>
                            </FormLabel>
                            <TextField
                                onChange={this.getNrTelefonu}
                                onClick={CONFIG.hotelKiosk === "1" ? this.openKlawiaturaTel : () => {}}
                                className={classes.floatLeft}
                                style={{ width: '85%' }}
                                variant="outlined"
                                inputProps={{ style: { backgroundColor: this.state.nrTelefonu ? this.props.page.secondaryLight : '#ffffff' } }}
                                InputProps={{ classes: { input: `${classes.primary} ${classes.input}` } }}
                                value={this.state.nrTelefonu}
                                type='number'
                                name='phone'
                            />
                        </FormControl>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.closeDialog} variant="outlined" size="small" color="primary"
                            style={{ textTransform: "none" }}
                        >
                            <b><Trans>Back</Trans></b>
                        </Button>
                        <Button
                            onClick={this.getReservation}
                            variant="contained" size="small" color="primary" style={{ textTransform: "none" }}
                            disabled={!this.state.nrRezerwacji.replace(/\s/g, "").match(/(^\d{1,}$)/)}
                        >
                            <b><Trans>Next</Trans></b>
                        </Button>
                    </DialogActions>
                </Dialog>

                <MuiThemeProvider theme={ selectTheme(this.props.page.windowTheme) }>
                <Dialog
                    disableEscapeKeyDown
                    maxWidth="xs"
                    open={this.state.openCancell}
                    onClose={this.closeDialog}
                    fullWidth
                >
                    <DialogTitle disableTypography>
                        {this.state.success ?
                            <Typography gutterBottom variant="h6" component="h2" color="primary"
                                className={`${classes.primary} ${classes.headline}`}>
                                <b><Trans>Success</Trans></b>
                            </Typography> :
                            <Typography gutterBottom variant="h6" component="h2" color="error"
                                className={` ${classes.headline}`}>
                                <b>{t("Failure").toLowerCase()}</b>
                            </Typography>}
                        <hr />
                    </DialogTitle>
                    <DialogContent>
                        {this.state.success ?
                            <DialogContentText className={classes.dialogContentText} style={{ paddingBottom: "10px" }}>
                                <Trans>Reservation nr</Trans>{' '}<Typography component="span" color="primary" style={{ fontWeight: "bold" }} >{this.state.nrRezerwacji}</Typography><Trans>Reserv had been canceled</Trans>
                            </DialogContentText> :
                            <DialogContentText className={classes.dialogContentText} style={{ paddingBottom: "10px" }}>
                                <Trans>Reservation nr</Trans>{' '}<Typography component="span" color="secondary"  style={{ fontWeight: "bold" }} >{this.state.nrRezerwacji}</Typography><Trans>Reserv had not been canceled</Trans>
                                <br />
                                <Trans>Try agin</Trans>
                            </DialogContentText>}

                    </DialogContent >
                    <DialogActions >
                        <Button onClick={this.closeDialog} variant="contained" size="small" color={this.state.success ? "primary" : "secondary"}
                            style={{ textTransform: "none" }}
                        >
                            <b><Trans>OK</Trans></b>
                        </Button>
                    </DialogActions>
                </Dialog>
                </MuiThemeProvider>
                
                
                <DialogZarzadzaj
                    open={this.state.openZarzadzaj}
                    cancellReservation={this.cancellReservation}
                    reservationId={Number(this.state.nrRezerwacji)}
                    dialogContent={this.state.dialogContentSuccess}
                    dialogContentFailure={this.state.dialogContentFailure}
                    titleFailure={t("Failure").toLowerCase()}
                    title={t("Success").toLowerCase()}
                    success={this.state.successDialogZarzadzaj}
                    paymentState={this.state.paymentState}
                    handleClose={this.handleCloseWithoutModal}
                    rezerwacjaPobyt={this.state.rezerwacjaPobyt}
                />
            </>
        );
    }
}

const mapStateToProps = (state: AppState) => ({
    page: state.pageState
});

const styles = (theme: Theme) => ({
    basket: {
        margin: '0px',
        padding: '0px'
    },
    basketTable: {
        margin: '0px',
        padding: '0px',
    },
    icon: {
        color: theme.palette.primary.dark,
        backgroundColor: theme.palette.background.default
    },
    confirm: {
        textShadow: "0 -1px 0 rgba(0, 0, 0, 0.25)",
        marginTop: "24px"
    },
    iconButton: {

    },
    badge: {
        color: theme.palette.secondary.light,
        backgroundColor: theme.palette.secondary.dark,
    },
    green: {
        color: theme.palette.primary.main
    },
    body: {
        fontSize: "12px",
        fontFamily: "\"Arial\", \"Helvetica\", sans-serif",
        lineHeight: "20px",
        fontWeight: theme.typography.body2.fontWeight
    },
    primary: {
        color: theme.palette.primary.main
    },
    error: {
        color: theme.palette.error.main
    },
    headline: {
        //fontFamily: "\"'Open Sans'\", sans-serif",
        lineHeight: "20px",
        //fontSize: "16px",
        //fontWeight: 600
    },
    dialogContentText: {
        whiteSpace: "pre" as "pre",
        paddingBottom: "6px"
        //fontSize: "14px"
    },
    primaryTextField: {
        color: theme.palette.primary.main,
        backgroundColor: "inherit",
        textAlign: 'left' as 'left',
    },
    dialogTitle: {
        padding: "0px"
    },
    hr: {
        marginTop: '10px'
    },
    floatLeft: {
        float: "left" as "left"
    },
    black: {
        color: "rgb(0, 0, 0)"
    },
    input: {
        padding: "8px 14px",
        fontWeight: 'normal' as 'normal',
        textAlign: 'left' as 'left'
    },
});

export default connect(mapStateToProps)(withTranslation()(withStyles(styles)(ZarzadzajRezerwacja)));
